import React from 'react';
import { SearchBar } from '../common';

function HeroSection() {
  return (
    <div className="pt-4 pb-8 lg:pt-8 lg:pb-16">
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 lg:gap-16 items-center">
        
        {/* Left Column - Content (3/5 of the space) */}
        <div className="lg:col-span-3 text-center lg:text-left">
          {/* Badge */}
          <div className="mb-8 inline-flex items-center gap-2 bg-white px-5 py-2 rounded-lg border border-[#254e70]/20 shadow-sm">
            <svg className="w-4 h-4 text-[#9dacff]" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
            </svg>
            <span className="text-sm font-semibold text-[#254e70]">Vetted, Licensed Therapists</span>
          </div>
          
          {/* Main Headline */}
          <h1 className="mb-6 text-5xl font-medium leading-tight tracking-tight text-[#254e70] lg:text-6xl xl:text-8xl">
            Find your{' '}
            <span className="text-[#9dacff]">perfect match</span>
            <br />
            in mental health care
          </h1>
          
          {/* Subheadline */}
          <p className="mb-8 text-lg leading-relaxed text-[#254e70]/70 lg:text-xl">
            Connect with licensed therapists who truly understand your needs. Browse verified profiles and book sessions that fit your schedule.
          </p>
          
          {/* Search Bar */}
          <div className="mb-8">
            <SearchBar 
              placeholder="Enter your location or search by specialty..."
              showExamples={true}
              size="large"
            />
          </div>
        </div>

        {/* Right Column - Larger Image (2/5 of the space) */}
        <div className="lg:col-span-2 relative">
          {/* Enhanced Professional Image */}
          <div className="relative">
            {/* Purple border frame */}
            <div className="absolute -inset-1 bg-[#9dacff] rounded-3xl opacity-75"></div>
            
            {/* Main image container */}
            <div className="relative rounded-3xl overflow-hidden shadow-xl md:shadow-2xl ring-1 ring-white/20 bg-white p-1">
              <div className="rounded-2xl overflow-hidden">
                <img 
                  src="http://counselingunconditionally.com/wp-content/uploads/2025/02/Courtney-Headshot-4.png"
                  alt="Professional Licensed Therapist"
                  className="w-full h-full object-cover aspect-[4/5]"
                />
                
                {/* Subtle overlay for depth */}
                <div className="absolute inset-0 bg-gradient-to-t from-[#254e70]/5 via-transparent to-transparent"></div>
              </div>
              
              {/* Single elegant callout - Top Right */}
              <div className="absolute top-6 right-6 bg-white/95 backdrop-blur-md rounded-2xl px-4 py-3 shadow-xl border border-white/30">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-[#9dacff] rounded-xl flex items-center justify-center">
                    <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div>
                    <p className="text-sm font-bold text-[#254e70] leading-tight">Accepting</p>
                    <p className="text-xs text-[#254e70]/70 leading-tight">New Clients</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Enhanced decorative background elements */}
          <div className="absolute -inset-2 md:-inset-8 bg-gradient-to-br from-[#9dacff]/20 via-transparent to-[#254e70]/10 rounded-3xl -z-10 blur-3xl"></div>
          <div className="absolute -inset-4 md:-inset-12 bg-gradient-to-tl from-[#254e70]/10 via-transparent to-[#9dacff]/15 rounded-3xl -z-20 blur-2xl"></div>
        </div>
      </div>
    </div>
  );
}

export default HeroSection; 